(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(global, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 889:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__webpack_require__(866);
__webpack_require__(726);
var FilteringDialog_1 = __importDefault(__webpack_require__(747));
var getPropertyData_1 = __webpack_require__(627);
var getFilteredData_1 = __webpack_require__(731);
var FilteringExtension = /** @class */ (function (_super) {
    __extends(FilteringExtension, _super);
    function FilteringExtension(viewer, options) {
        var _this = this;
        var _a, _b, _c, _d;
        _this = _super.call(this, viewer, options) || this;
        _this.viewer = viewer;
        _this.options = {
            callbacks: {
                onSearch: ((_a = options === null || options === void 0 ? void 0 : options.callbacks) === null || _a === void 0 ? void 0 : _a.onSearch) || ((_b = options === null || options === void 0 ? void 0 : options.callbacks) === null || _b === void 0 ? void 0 : _b.onFiltering),
                onCancel: ((_c = options === null || options === void 0 ? void 0 : options.callbacks) === null || _c === void 0 ? void 0 : _c.onCancel) || ((_d = options === null || options === void 0 ? void 0 : options.callbacks) === null || _d === void 0 ? void 0 : _d.onFiltering),
            },
        };
        _this.controlGroup = null;
        _this.aggregatedPropertyMap = {};
        _this.filteredObjects = {};
        _this.dialogs = {};
        _this.listeners = {};
        _this.addedModels = [];
        _this.loadQueue = [];
        _this.filterButton = new Autodesk.Viewing.UI.Button('ft-control-button');
        return _this;
    }
    FilteringExtension.prototype.load = function () {
        this.bindEvents();
        return true;
    };
    FilteringExtension.prototype.unload = function () {
        this.deleteControlGroup();
        this.deleteDialogs();
        this.unbindEvents();
        return true;
    };
    FilteringExtension.prototype.getFilteredObjects = function (filters) {
        return __awaiter(this, void 0, void 0, function () {
            var models, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        models = this.viewer.getVisibleModels();
                        _a = this;
                        return [4 /*yield*/, (0, getFilteredData_1.getFilteredData)(models, this.aggregatedPropertyMap, filters)];
                    case 1:
                        _a.filteredObjects = _b.sent();
                        this.filterButton.addClass('filtering-on');
                        return [2 /*return*/, this.filteredObjects];
                }
            });
        });
    };
    FilteringExtension.prototype.addEventListener = function (name, callback) {
        var _a;
        this.listeners[name] = (_a = {},
            _a[String(Math.random()).substring(2, 24)] = callback,
            _a);
    };
    FilteringExtension.prototype.clear = function () {
        this.filteredObjects = {};
        this.filterButton.removeClass('filtering-on');
    };
    FilteringExtension.prototype.handleToolbarButtonClick = function () {
        if (this.dialogs.filtering.isVisible()) {
            this.closeDialog('filtering');
        }
        else {
            this.openDialog('filtering');
        }
    };
    FilteringExtension.prototype.handleToolbarCreated = function () {
        this.createControlGroup();
    };
    FilteringExtension.prototype.handleModelAdded = function (event) {
        var urn = event.model.getData().urn;
        if (!this.addedModels.includes(urn)) {
            this.addedModels.push(urn);
        }
        this.dispatchEvent('fe:model.added');
    };
    FilteringExtension.prototype.handleModelLoaded = function (event) {
        var _this = this;
        this.dispatchEvent('fe:model.loaded');
        this.loadQueue.push(event.model);
        if (this.addedModels.length === this.loadQueue.length) {
            Promise.all(this.loadQueue.map(function (loadedModel) {
                return new Promise(function (resolve) {
                    var urn = loadedModel.getData().urn;
                    var it = loadedModel.getInstanceTree();
                    var dbIds = Object.keys(it.nodeAccess.dbIdToIndex).map(Number);
                    (0, getPropertyData_1.getPropertyData)(loadedModel, dbIds).then(function (propertyMap) {
                        _this.aggregatedPropertyMap[urn] = propertyMap;
                        resolve();
                    });
                });
            })).then(function () {
                _this.addedModels = [];
                _this.loadQueue = [];
                _this.clear();
                _this.dispatchEvent('fe:queue.proccessed', _this.aggregatedPropertyMap);
            });
        }
    };
    FilteringExtension.prototype.handleModelRemoved = function () {
        this.dispatchEvent('fe:model.removed');
    };
    FilteringExtension.prototype.handleModelUnloaded = function () {
        var _this = this;
        this.dispatchEvent('fe:model.unloaded');
        var models = this.viewer.getAllModels();
        Object.keys(this.aggregatedPropertyMap).forEach(function (urn) {
            if (!models.some(function (model) { return model.getData().urn === urn; })) {
                delete _this.aggregatedPropertyMap[urn];
            }
        });
        this.clear();
        this.dispatchEvent('fe:queue.proccessed', this.aggregatedPropertyMap);
    };
    FilteringExtension.prototype.handleExtensionLoaded = function (event) {
        if (event.extensionId === 'BIMSoft.Extensions.Filtering') {
            this.createDialogs();
        }
    };
    FilteringExtension.prototype.createControlGroup = function () {
        var controlGroup = this.viewer.toolbar.getControl('gv-control-group');
        this.filterButton.setIcon('ft-control-icon');
        this.filterButton.setToolTip('Фильтр');
        this.filterButton.addEventListener('click', this.handleToolbarButtonClick);
        if (controlGroup) {
            controlGroup.addControl(this.filterButton);
        }
        else {
            controlGroup = new Autodesk.Viewing.UI.ControlGroup('gv-control-group');
            controlGroup.addControl(this.filterButton);
            this.viewer.toolbar.addControl(controlGroup);
        }
        this.controlGroup = controlGroup;
    };
    FilteringExtension.prototype.deleteControlGroup = function () {
        if (!this.controlGroup)
            return;
        this.controlGroup.removeControl('ft-control-button');
        if (!this.controlGroup.getNumberOfControls()) {
            this.controlGroup.removeFromParent();
            this.controlGroup = null;
        }
    };
    FilteringExtension.prototype.createDialogs = function () {
        this.dialogs.filtering = new FilteringDialog_1.default(this.viewer, this.options);
    };
    FilteringExtension.prototype.deleteDialogs = function () {
        var _this = this;
        Object.keys(this.dialogs).forEach(function (name) {
            _this.dialogs[name].uninitialize();
        });
        this.dialogs = {};
    };
    FilteringExtension.prototype.openDialog = function (name) {
        if (!this.dialogs[name])
            return;
        this.dialogs[name].setVisible(true);
    };
    FilteringExtension.prototype.closeDialog = function (name) {
        if (!this.dialogs[name])
            return;
        this.dialogs[name].setVisible(false);
    };
    FilteringExtension.prototype.bindEvents = function () {
        this.handleToolbarButtonClick = this.handleToolbarButtonClick.bind(this);
        this.handleToolbarCreated = this.handleToolbarCreated.bind(this);
        this.handleModelAdded = this.handleModelAdded.bind(this);
        this.handleModelLoaded = this.handleModelLoaded.bind(this);
        this.handleModelRemoved = this.handleModelRemoved.bind(this);
        this.handleModelUnloaded = this.handleModelUnloaded.bind(this);
        this.handleExtensionLoaded = this.handleExtensionLoaded.bind(this);
        this.viewer.addEventListener(Autodesk.Viewing.TOOLBAR_CREATED_EVENT, this.handleToolbarCreated);
        this.viewer.addEventListener(Autodesk.Viewing.MODEL_ADDED_EVENT, this.handleModelAdded);
        this.viewer.addEventListener(Autodesk.Viewing.OBJECT_TREE_CREATED_EVENT, this.handleModelLoaded);
        this.viewer.addEventListener(Autodesk.Viewing.MODEL_REMOVED_EVENT, this.handleModelRemoved);
        this.viewer.addEventListener(Autodesk.Viewing.MODEL_UNLOADED_EVENT, this.handleModelUnloaded);
        this.viewer.addEventListener(Autodesk.Viewing.EXTENSION_LOADED_EVENT, this.handleExtensionLoaded);
    };
    FilteringExtension.prototype.unbindEvents = function () {
        this.viewer.removeEventListener(Autodesk.Viewing.TOOLBAR_CREATED_EVENT, this.handleToolbarCreated);
        this.viewer.removeEventListener(Autodesk.Viewing.MODEL_ADDED_EVENT, this.handleModelAdded);
        this.viewer.removeEventListener(Autodesk.Viewing.OBJECT_TREE_CREATED_EVENT, this.handleModelLoaded);
        this.viewer.removeEventListener(Autodesk.Viewing.MODEL_REMOVED_EVENT, this.handleModelRemoved);
        this.viewer.removeEventListener(Autodesk.Viewing.MODEL_UNLOADED_EVENT, this.handleModelUnloaded);
        this.viewer.removeEventListener(Autodesk.Viewing.EXTENSION_LOADED_EVENT, this.handleExtensionLoaded);
    };
    FilteringExtension.prototype.dispatchEvent = function (name) {
        var options = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            options[_i - 1] = arguments[_i];
        }
        if (!this.listeners[name])
            return;
        var listener = this.listeners[name];
        Object.keys(listener).forEach(function (key) {
            var _a;
            (_a = listener[key]).call.apply(_a, __spreadArray([null], __read(options), false));
        });
    };
    return FilteringExtension;
}(Autodesk.Viewing.Extension));
exports["default"] = FilteringExtension;


/***/ }),

/***/ 731:
/***/ (function(__unused_webpack_module, exports) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getFilteredData = void 0;
function getFilteredData(visibleModels, aggregatedProperties, filters) {
    return __awaiter(this, void 0, void 0, function () {
        var searchStrings, urnsInSearch, inSearchModels, filteredArr, filteredObjects;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    searchStrings = filters.reduce(function (acc, next) { return __spreadArray(__spreadArray([], __read(acc), false), [next.name], false); }, []);
                    urnsInSearch = Object.keys(aggregatedProperties).filter(function (urn) {
                        return searchStrings.some(function (searchStr) {
                            return Object.keys(aggregatedProperties[urn]).includes(searchStr);
                        });
                    });
                    inSearchModels = visibleModels.filter(function (model) {
                        return urnsInSearch.includes(model.getData().urn);
                    });
                    return [4 /*yield*/, Promise.all(inSearchModels.map(function (model) { return __awaiter(_this, void 0, void 0, function () {
                            var urn, it, dbIds, result;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        urn = model.getData().urn;
                                        it = model.getInstanceTree();
                                        dbIds = Object.keys(it.nodeAccess.dbIdToIndex).map(Number);
                                        return [4 /*yield*/, model.getPropertyDb().executeUserFunction(function userFunction(pdb, params) {
                                                var filters = params.filters, dbIds = params.dbIds;
                                                var matchedIds = [];
                                                // Код бимСофта пока не трогаем
                                                var operands = {
                                                    Равно: function (a, b) { return a == b; },
                                                    'Не равно': function (a, b) {
                                                        return a != b;
                                                    },
                                                    Больше: function (a, b) { return a > b; },
                                                    Меньше: function (a, b) { return a < b; },
                                                    'Больше или равно': function (a, b) { return a >= b; },
                                                    'Меньше или равно': function (a, b) { return a <= b; },
                                                    Содержит: function (a, b) {
                                                        return String(a).includes(String(b));
                                                    },
                                                    'Не содержит': function (a, b) {
                                                        return !String(a).includes(String(b));
                                                    },
                                                };
                                                var _loop_1 = function (i) {
                                                    var dbId = dbIds[i];
                                                    var matches = 0;
                                                    filters.forEach(function (filter) {
                                                        var obj = pdb.getObjectProperties(dbId, null, true);
                                                        if (!operands[filter.operand]) {
                                                            return;
                                                        }
                                                        for (var y = 0; y < obj.properties.length; y++) {
                                                            var prop = obj.properties[y];
                                                            var propertyValue = prop.displayValue;
                                                            var filterValue = filter.value;
                                                            var displayName = prop.displayName;
                                                            if ([
                                                                'Больше',
                                                                'Меньше',
                                                                'Больше или равно',
                                                                'Меньше или равно',
                                                            ].includes(filter.operand)) {
                                                                if (typeof propertyValue === 'string' &&
                                                                    filter.type === 'string') {
                                                                    if (!isNaN(Number(propertyValue))) {
                                                                        propertyValue = Number(propertyValue);
                                                                    }
                                                                    else if (!isNaN(Number(filterValue))) {
                                                                        filterValue = Number(filterValue);
                                                                    }
                                                                }
                                                            }
                                                            if (filter.name === displayName &&
                                                                operands[filter.operand](propertyValue, filterValue)) {
                                                                matches += 1;
                                                            }
                                                        }
                                                        if (matches === filters.length) {
                                                            matchedIds.push(dbId);
                                                        }
                                                    });
                                                };
                                                for (var i = 0; i < dbIds.length; i++) {
                                                    _loop_1(i);
                                                }
                                                return matchedIds;
                                            }, { filters: filters, dbIds: dbIds })];
                                    case 1:
                                        result = _b.sent();
                                        return [2 /*return*/, (_a = {}, _a[urn] = result, _a)];
                                }
                            });
                        }); }))];
                case 1:
                    filteredArr = _a.sent();
                    filteredObjects = filteredArr.reduce(function (acc, next) { return (__assign(__assign({}, acc), next)); }, {});
                    return [2 /*return*/, filteredObjects];
            }
        });
    });
}
exports.getFilteredData = getFilteredData;


/***/ }),

/***/ 627:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getPropertyData = void 0;
function getPropertyData(model, dbIds) {
    return model
        .getPropertyDb()
        .executeUserFunction(function userFunction(pdb, dbIds) {
        var propertyMap = new Map();
        dbIds.forEach(function (id) {
            var obj = pdb.getObjectProperties(id, null, true);
            if (obj.properties.length) {
                obj.properties.forEach(function (p) {
                    if (p.displayCategory.startsWith('__')) {
                        return;
                    }
                    if (propertyMap.has(p.displayName)) {
                        var values = propertyMap.get(p.displayName);
                        propertyMap.set(p.displayName, values.includes(p.displayValue)
                            ? values
                            : values.concat(p.displayValue));
                    }
                    else {
                        propertyMap.set(p.displayName, [p.displayValue]);
                    }
                });
            }
        });
        return Object.fromEntries(propertyMap);
    }, dbIds);
}
exports.getPropertyData = getPropertyData;


/***/ }),

/***/ 747:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var components_1 = __webpack_require__(19);
var utils_1 = __webpack_require__(58);
var templates_1 = __importDefault(__webpack_require__(924));
var FilteringDialog = /** @class */ (function (_super) {
    __extends(FilteringDialog, _super);
    function FilteringDialog(viewer, options) {
        var _this = _super.call(this, viewer.container, 'filtering', 'filtering') || this;
        _this.viewer = viewer;
        _this.options = options;
        _this.fe = viewer.getExtension('BIMSoft.Extensions.Filtering');
        _this.isolated = false;
        _this.propertyList = [];
        _this.propertyValues = {};
        _this.rows = {};
        _this.createDialog();
        _this.bindEvents();
        _this.loader = new components_1.Loader(_this.container);
        _this.selectFieldManager = new components_1.SelectFieldManager(_this.viewer.container, _this.container);
        _this.selectFieldManager.initialize();
        return _this;
    }
    FilteringDialog.prototype.resetFilters = function () {
        var _this = this;
        this.container.querySelector('.gv-alert [data-title]').innerText =
            'Условие не задано';
        __spreadArray([], __read(this.container.querySelectorAll('.ft-table__body-row')), false).forEach(function (element) {
            var row = element.closest('.ft-table__body-row');
            if (!row)
                return;
            var id = row.getAttribute('data-id');
            if (!id)
                return;
            _this.rows[id].self.remove();
            delete _this.rows[id];
        });
    };
    FilteringDialog.prototype.createDialog = function () {
        var dialog = templates_1.default.createDialog();
        this.container.id = 'filtering';
        this.container.innerHTML = '';
        this.container.appendChild(dialog);
        this.initializeMoveHandlers(dialog.querySelector('[data-header]'));
        this.initializeCloseHandler(dialog.querySelector('[data-action="CLOSE_DIALOG"]'));
    };
    FilteringDialog.prototype.createRow = function () {
        var id = String(Math.random()).substring(2, 24);
        var row = templates_1.default.createRow(id);
        this.rows[id] = {
            self: row,
            fields: {
                name: row.querySelector('.gv-select-field[name="name"]'),
                operand: row.querySelector('.gv-select-field[name="operand"]'),
                value: row.querySelector('.gv-select-field[name="value"]'),
            },
        };
        this.container.querySelector('.ft-table [data-body]').appendChild(row);
    };
    FilteringDialog.prototype.deleteRows = function () {
        var _this = this;
        ;
        __spreadArray([], __read(this.container.querySelectorAll('.ft-table__body-row input[type="checkbox"]:checked')), false).forEach(function (element) {
            var row = element.closest('.ft-table__body-row');
            if (!row)
                return;
            var id = row.getAttribute('data-id');
            if (!id)
                return;
            _this.rows[id].self.remove();
            delete _this.rows[id];
        });
    };
    FilteringDialog.prototype.toggleIsolation = function () {
        if (this.isolated) {
            this.unisolate();
        }
        else {
            this.isolate();
        }
    };
    FilteringDialog.prototype.isolate = function () {
        var label = this.container.querySelector('.gv-button[data-action="TOGGLE_ISOLATION"] [data-label]');
        if (!label)
            return;
        (0, utils_1.isolate)(this.viewer, this.fe.filteredObjects);
        this.isolated = true;
        label.innerText = 'Сброс изоляции';
    };
    FilteringDialog.prototype.unisolate = function () {
        var label = this.container.querySelector('.gv-button[data-action="TOGGLE_ISOLATION"] [data-label]');
        if (!label)
            return;
        (0, utils_1.unisolate)(this.viewer);
        this.isolated = false;
        label.innerText = 'Изолировать';
    };
    FilteringDialog.prototype.search = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var filteredObjects, desiredObjects, availableObjects;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.loader.show('Идет расчет результатов.');
                        return [4 /*yield*/, this.fe.getFilteredObjects(this.getFilters())];
                    case 1:
                        filteredObjects = _c.sent();
                        desiredObjects = 0;
                        availableObjects = 0;
                        this.viewer.getAllModels().forEach(function (model) {
                            var _a;
                            var urn = model.getData().urn;
                            desiredObjects += ((_a = filteredObjects[urn]) === null || _a === void 0 ? void 0 : _a.length) || 0;
                            availableObjects += Object.keys(model.getInstanceTree().nodeAccess.dbIdToIndex).length;
                        });
                        this.container.querySelector('.gv-alert [data-title]').innerText = "".concat(desiredObjects, " / ").concat(availableObjects, " \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0442 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C \u0444\u0438\u043B\u044C\u0442\u0440\u0430");
                        this.loader.hide();
                        if ((_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.callbacks) === null || _b === void 0 ? void 0 : _b.onSearch) {
                            this.options.callbacks.onSearch(this.fe.filteredObjects);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FilteringDialog.prototype.cancel = function () {
        var _a, _b;
        this.resetFilters();
        this.unisolate();
        this.fe.clear();
        if ((_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.callbacks) === null || _b === void 0 ? void 0 : _b.onCancel) {
            this.options.callbacks.onCancel(this.fe.filteredObjects);
        }
    };
    FilteringDialog.prototype.fillPropertyValue = function (selectField, propName) {
        return __awaiter(this, void 0, void 0, function () {
            var valueArr, propertyValues;
            return __generator(this, function (_a) {
                valueArr = this.propertyValues[propName];
                if (!valueArr.length) {
                    return [2 /*return*/];
                }
                propertyValues = valueArr.map(function (value) { return ({
                    value: value,
                    type: typeof value,
                }); });
                selectField.setAttribute('data-items', JSON.stringify(propertyValues));
                return [2 /*return*/];
            });
        });
    };
    FilteringDialog.prototype.fillPropertyName = function (selectField) {
        var propertyNames = this.propertyList.map(function (name) { return ({
            value: name,
            type: 'string',
        }); });
        selectField.setAttribute('data-items', JSON.stringify(propertyNames));
    };
    FilteringDialog.prototype.clickController = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var selectField, row, id, element, item;
            return __generator(this, function (_a) {
                selectField = event.target.closest('.gv-select-field');
                row = selectField.closest('.ft-table__body-row[data-id]');
                id = row.getAttribute('data-id');
                element = selectField.getAttribute('name');
                if (!row || !id || !selectField || !element) {
                    return [2 /*return*/];
                }
                item = JSON.parse(this.rows[id].fields.name.getAttribute('data-item') || '{}');
                if (element === 'value' && item.value) {
                    this.fillPropertyValue(selectField, item.value);
                }
                if (element === 'name') {
                    this.fillPropertyName(selectField);
                }
                return [2 /*return*/];
            });
        });
    };
    FilteringDialog.prototype.getFilters = function () {
        var _this = this;
        var rows = __spreadArray([], __read(this.container.querySelectorAll('.ft-table__body-row')), false);
        if (!rows.length)
            return [];
        return rows.reduce(function (accumulator, row) {
            var _a, _b, _c, _d;
            var id = row.getAttribute('data-id');
            if (!id)
                return accumulator;
            var name = (_a = JSON.parse(_this.rows[id].fields.name.getAttribute('data-item') || '{}')) === null || _a === void 0 ? void 0 : _a.value;
            var operand = (_b = JSON.parse(_this.rows[id].fields.operand.getAttribute('data-item') || '{}')) === null || _b === void 0 ? void 0 : _b.value;
            var value = (_c = JSON.parse(_this.rows[id].fields.value.getAttribute('data-item') || '{}')) === null || _c === void 0 ? void 0 : _c.value;
            var type = (_d = JSON.parse(_this.rows[id].fields.value.getAttribute('data-item') || '{}')) === null || _d === void 0 ? void 0 : _d.type;
            if (!name || !operand || !value || !type)
                return accumulator;
            accumulator.push({
                name: name,
                operand: operand,
                value: value,
                type: type,
            });
            return accumulator;
        }, []);
    };
    FilteringDialog.prototype.selectAll = function () {
        var _this = this;
        if (!Object.keys(this.fe.filteredObjects).length)
            return;
        this.viewer.clearSelection();
        this.viewer.impl.selector.setAggregateSelection(Object.keys(this.fe.filteredObjects).map(function (urn) { return ({
            model: (0, utils_1.getModel)(_this.viewer, urn),
            ids: _this.fe.filteredObjects[urn],
        }); }));
    };
    FilteringDialog.prototype.handleContainerClick = function (event) {
        var action = event.target.closest('[data-action]');
        if (!action)
            return;
        var type = action.getAttribute('data-action');
        if (!type)
            return;
        switch (type) {
            case 'CLICK_CONTROLLER':
                this.clickController(event);
                break;
            case 'CREATE_ROW':
                this.createRow();
                break;
            case 'DELETE_ROWS':
                this.deleteRows();
                break;
            case 'TOGGLE_ISOLATION':
                this.toggleIsolation();
                break;
            case 'SEARCH':
                this.search();
                break;
            case 'SELECT_ALL':
                this.selectAll();
                break;
            case 'CANCEL':
                this.cancel();
                break;
            default:
                break;
        }
    };
    FilteringDialog.prototype.handleContainerInput = function (event) {
        var selectField = event.target.closest('.gv-select-field');
        if (!selectField)
            return;
        var name = selectField.getAttribute('name');
        if (!name)
            return;
        var row = selectField.closest('.ft-table__body-row[data-id]');
        if (!row)
            return;
        var id = row.getAttribute('data-id');
        if (!id)
            return;
        if (name === 'name') {
            var controller = this.rows[id].fields.value.querySelector('input[type="text"]');
            if (!controller)
                return;
            controller.value = '';
        }
    };
    FilteringDialog.prototype.handleModelAdded = function () {
        this.loader.show('Набор моделей загружается. Расчет объектов сводной модели.');
    };
    FilteringDialog.prototype.handleModelRemoved = function () {
        this.loader.show();
    };
    FilteringDialog.prototype.handleQueueProccessed = function (aggregatedPropertyMap) {
        var propertyList = [];
        var propertyValues = {};
        Object.values(aggregatedPropertyMap).forEach(function (propertyMap) {
            var newProps = Object.keys(propertyMap);
            var propertySet = new Set();
            if (propertyList.length) {
                propertyList.forEach(function (p) { return propertySet.add(p); });
            }
            newProps.forEach(function (p) { return propertySet.add(p); });
            var newPropertyList = Array.from(propertySet);
            var values = Object.values(aggregatedPropertyMap).reduce(function (acc, next) { return (__assign(__assign({}, acc), next)); }, {});
            var valueMap = newPropertyList.reduce(function (acc, next) {
                var _a, _b;
                var newValue = values[next] || [];
                var oldVal = propertyValues[next] || [];
                if (oldVal.length) {
                    return __assign(__assign({}, acc), (_a = {}, _a[next] = __spreadArray(__spreadArray([], __read(oldVal), false), __read(newValue.filter(function (v) { return !oldVal.includes(v); })), false), _a));
                }
                return __assign(__assign({}, acc), (_b = {}, _b[next] = newValue, _b));
            }, {});
            propertyValues = valueMap;
            propertyList = newPropertyList;
        });
        this.propertyValues = propertyValues;
        this.propertyList = propertyList.sort(function (a, b) { return a.localeCompare(b); });
        if (Object.keys(this.rows).length) {
            this.search();
        }
        this.unisolate();
        this.loader.hide();
    };
    FilteringDialog.prototype.bindEvents = function () {
        this.handleContainerClick = this.handleContainerClick.bind(this);
        this.handleContainerInput = this.handleContainerInput.bind(this);
        this.handleModelAdded = this.handleModelAdded.bind(this);
        this.handleModelRemoved = this.handleModelRemoved.bind(this);
        this.handleQueueProccessed = this.handleQueueProccessed.bind(this);
        this.container.addEventListener('click', this.handleContainerClick);
        this.container.addEventListener('input', this.handleContainerInput);
        this.fe.addEventListener('fe:model.added', this.handleModelAdded);
        this.fe.addEventListener('fe:model.removed', this.handleModelRemoved);
        this.fe.addEventListener('fe:queue.proccessed', this.handleQueueProccessed);
    };
    return FilteringDialog;
}(Autodesk.Viewing.UI.DockingPanel));
exports["default"] = FilteringDialog;


/***/ }),

/***/ 924:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = {
    createDialog: function () {
        var element = document.createElement('div');
        element.classList.add('gv-dialog');
        element.innerHTML = "\n      <div class=\"gv-dialog__inner\">\n        <div class=\"gv-dialog__header\" data-header style=\"cursor: move;\">\n          <div class=\"gv-dialog__header-outer\">\n            <div class=\"gv-dialog__header-inner\">\n              <div class=\"gv-dialog__header-title\">\u0424\u0438\u043B\u044C\u0442\u0440</div>\n\n              <div class=\"gv-dialog__icon\" data-action=\"CLOSE_DIALOG\">\n                <div class=\"gv-dialog__icon-inner\">\n                  <svg focusable=\"false\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" tabindex=\"-1\">\n                    <path d=\"M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"></path>\n                  </svg>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"gv-dialog__body gv-scrollbar\" data-body>\n          <div class=\"gv-dialog__body-outer\">\n            <div class=\"gv-dialog__body-inner\">\n              <div class=\"gv-space gv-space--direction-vertical\" style=\"gap: 12px;\">\n                <div class=\"gv-alert gv-alert--theme-information\">\n                  <div class=\"gv-alert__outer\">\n                    <div class=\"gv-alert__icon gv-alert__icon--position-prefix\">\n                      <div class=\"gv-alert__icon-inner\">\n                        <svg focusable=\"false\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" tabindex=\"-1\"><path d=\"M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z\"></path>\n                        </svg>\n                      </div>\n                    </div>\n\n                    <div class=\"gv-alert__inner\">\n                      <div class=\"gv-alert__title\">\n                        <div class=\"gv-alert__title-inner\" data-title>\u0423\u0441\u043B\u043E\u0432\u0438\u0435 \u043D\u0435 \u0437\u0430\u0434\u0430\u043D\u043E</div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n\n                <table class=\"ft-table\">\n                  <thead class=\"ft-table__header\" data-header>\n                    <tr class=\"ft-table__header-row\">\n                      <td class=\"ft-table__header-cell\"></td>\n                      <td class=\"ft-table__header-cell\">\u0421\u0432\u043E\u0439\u0441\u0442\u0432\u043E</td>\n                      <td class=\"ft-table__header-cell\">\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F</td>\n                      <td class=\"ft-table__header-cell\">\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435</td>\n                      <th class=\"ft-table__header-cell\">\n                        <div class=\"ft-table__icons\">\n                          <div class=\"ft-table__icons-inner\">\n                            <div class=\"ft-table__icon\" data-action=\"CREATE_ROW\" title=\"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0443\u0441\u043B\u043E\u0432\u0438\u0435\">\n                              <div class=\"ft-table__icon-inner\">\n                                <svg focusable=\"false\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" tabindex=\"-1\"><path d=\"M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z\"></path></svg>\n                              </div>\n                            </div>\n\n                            <div class=\"ft-table__icon\" data-action=\"DELETE_ROWS\" title=\"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\">\n                              <div class=\"ft-table__icon-inner\">\n                                <svg focusable=\"false\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" tabindex=\"-1\">\n                                  <path d=\"M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z\"></path>\n                                </svg>\n                              </div>\n                            </div>\n                          </div>\n                        </div>\n                      </th>\n                    </tr>\n                  </thead>\n\n                  <tbody class=\"ft-table__body\" data-body></tbody>\n                </table>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"gv-dialog__footer\">\n          <div class=\"gv-dialog__footer-outer\">\n            <div class=\"gv-dialog__footer-inner\">\n              <button class=\"gv-button\" data-action=\"TOGGLE_ISOLATION\">\n                <div class=\"gv-button__inner\">\n                  <div class=\"gv-button__label\">\n                    <div class=\"gv-button__label-inner\" data-label>\u0418\u0437\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C</div>\n                  </div>\n                </div>\n              </button>\n\n              <button class=\"gv-button\" data-action=\"SEARCH\">\n                <div class=\"gv-button__inner\">\n                  <div class=\"gv-button__label\">\n                    <div class=\"gv-button__label-inner\" data-label>\u041F\u043E\u0438\u0441\u043A</div>\n                  </div>\n                </div>\n              </button>\n\n              <button class=\"gv-button\" data-action=\"SELECT_ALL\">\n                <div class=\"gv-button__inner\">\n                  <div class=\"gv-button__label\">\n                    <div class=\"gv-button__label-inner\" data-label>\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C \u0432\u0441\u0435</div>\n                  </div>\n                </div>\n              </button>\n\n              <button class=\"gv-button\" data-action=\"CANCEL\">\n                <div class=\"gv-button__inner\">\n                  <div class=\"gv-button__label\">\n                    <div class=\"gv-button__label-inner\" data-label>\u0421\u0431\u0440\u043E\u0441</div>\n                  </div>\n                </div>\n              </button>\n            </div>\n\n            <div class=\"gv-dialog__footer-resizer\"></div>\n          </div>\n        </div>\n      </div>\n    ";
        return element;
    },
    createRow: function (id) {
        var element = document.createElement('tr');
        element.classList.add('ft-table__body-row');
        element.setAttribute('data-id', id);
        element.innerHTML = "\n      <td class=\"ft-table__body-cell\">\n        <div class=\"gv-checkbox\">\n          <div class=\"gv-checkbox__inner\">\n            <input type=\"checkbox\">\n\n            <div class=\"gv-checkbox__icons\">\n              <div class=\"gv-checkbox__icons-inner\">\n                <div class=\"gv-checkbox__icon\" name=\"unchecked\">\n                  <div class=\"gv-checkbox__icon-inner\">\n                    <svg focusable=\"false\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" tabindex=\"-1\">\n                      <path d=\"M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z\"></path>\n                    </svg>\n                  </div>\n                </div>\n\n                <div class=\"gv-checkbox__icon\" name=\"checked\">\n                  <div class=\"gv-checkbox__icon-inner\">\n                    <svg focusable=\"false\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" tabindex=\"-1\">\n                      <path d=\"M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM17.99 9l-1.41-1.42-6.59 6.59-2.58-2.57-1.42 1.41 4 3.99z\"></path>\n                    </svg>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </td>\n      <td class=\"ft-table__body-cell\">\n        <div class=\"gv-select-field\" name=\"name\">\n          <div class=\"gv-select-field__inner\">\n            <div class=\"gv-select-field__controller\" data-action=\"CLICK_CONTROLLER\">\n              <div class=\"gv-select-field__controller-inner\">\n                <input type=\"text\" placeholder=\"\u0421\u0432\u043E\u0439\u0441\u0442\u0432\u043E\" autocomplete=\"off\">\n              </div>\n            </div>\n          </div>\n        </div>\n      </td>\n      <td class=\"ft-table__body-cell\">\n        <div class=\"gv-select-field\" name=\"operand\" data-items='[{\"value\":\"\u0420\u0430\u0432\u043D\u043E\",\"type\":\"string\"},{\"value\":\"\u041D\u0435 \u0440\u0430\u0432\u043D\u043E\",\"type\":\"string\"},{\"value\":\"\u0411\u043E\u043B\u044C\u0448\u0435\",\"type\":\"string\"},{\"value\":\"\u041C\u0435\u043D\u044C\u0448\u0435\",\"type\":\"string\"},{\"value\":\"\u0411\u043E\u043B\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E\",\"type\":\"string\"},{\"value\":\"\u041C\u0435\u043D\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E\",\"type\":\"string\"},{\"value\":\"\u0421\u043E\u0434\u0435\u0440\u0436\u0438\u0442\",\"type\":\"string\"},{\"value\": \"\u041D\u0435 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442\", \"type\": \"string\"}]'>\n          <div class=\"gv-select-field__inner\">\n            <div class=\"gv-select-field__controller\" data-action=\"CLICK_CONTROLLER\">\n              <div class=\"gv-select-field__controller-inner\">\n                <input type=\"text\" placeholder=\"\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F\" autocomplete=\"off\">\n              </div>\n            </div>\n          </div>\n        </div>\n      </td>\n      <td class=\"ft-table__body-cell\">\n        <div class=\"gv-select-field\" name=\"value\">\n          <div class=\"gv-select-field__inner\">\n            <div class=\"gv-select-field__controller\" data-action=\"CLICK_CONTROLLER\">\n              <div class=\"gv-select-field__controller-inner\">\n                <input type=\"text\" placeholder=\"\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435\" autocomplete=\"off\">\n              </div>\n            </div>\n          </div>\n        </div>\n      </td>\n      <td class=\"ft-table__body-cell\"></td>\n    ";
        return element;
    },
};


/***/ }),

/***/ 607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FilteringExtension = void 0;
var FilteringExtension_1 = __webpack_require__(889);
Object.defineProperty(exports, "FilteringExtension", ({ enumerable: true, get: function () { return __importDefault(FilteringExtension_1).default; } }));
__exportStar(__webpack_require__(679), exports);
__exportStar(__webpack_require__(686), exports);


/***/ }),

/***/ 679:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 686:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 866:
/***/ ((module) => {

module.exports = require("@bimsoft/styles/lib/index.min.css");

/***/ }),

/***/ 19:
/***/ ((module) => {

module.exports = require("@bimsoft/ulib/lib/components");

/***/ }),

/***/ 726:
/***/ ((module) => {

module.exports = require("@bimsoft/ulib/lib/namespace");

/***/ }),

/***/ 58:
/***/ ((module) => {

module.exports = require("@bimsoft/ulib/lib/utils");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(607);
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});